import { create } from 'zustand';
import type { ConversationStatus } from '@/types/chat.types';

interface ChatState {
  selectedConversationId: string | null;
  searchQuery: string;
  statusFilter: ConversationStatus | null;
  assignedToFilter: string | null;
  wsConnected: boolean;
  wsReconnecting: boolean;

  setSelectedConversation: (id: string | null) => void;
  setSearchQuery: (query: string) => void;
  setStatusFilter: (status: ConversationStatus | null) => void;
  setAssignedToFilter: (userId: string | null) => void;
  setWsConnected: (connected: boolean) => void;
  setWsReconnecting: (reconnecting: boolean) => void;
}

export const useChatStore = create<ChatState>()((set) => ({
  selectedConversationId: null,
  searchQuery: '',
  statusFilter: null,
  assignedToFilter: null,
  wsConnected: false,
  wsReconnecting: false,

  setSelectedConversation: (id) => set({ selectedConversationId: id }),
  setSearchQuery: (query) => set({ searchQuery: query }),
  setStatusFilter: (status) => set({ statusFilter: status, assignedToFilter: null }),
  setAssignedToFilter: (userId) => set({ assignedToFilter: userId, statusFilter: null }),
  setWsConnected: (connected) => set({ wsConnected: connected }),
  setWsReconnecting: (reconnecting) => set({ wsReconnecting: reconnecting }),
}));
